/**
 * UI Manager for handling UI state and messages
 */
export class UIManager {
  private statusElement: HTMLElement | null;
  private messagesElement: HTMLElement | null;

  constructor() {
    this.statusElement = document.getElementById('status');
    this.messagesElement = document.getElementById('messages');
  }

  /**
   * Set status message
   */
  public setStatus(message: string): void {
    if (this.statusElement) {
      this.statusElement.textContent = message;
    }
  }

  /**
   * Update loading progress (0.0 - 1.0)
   */
  public setLoadingProgress(percentage: number): void {
    if (!this.statusElement) return;

    const clamped = Math.max(0, Math.min(1, percentage));
    const percentText = Math.round(clamped * 100);
    this.statusElement.textContent = `Loading model... ${percentText}%`;
  }

  /**
   * Add a message with styling
   */
  public addMessage(
    message: string,
    type: 'info' | 'warning' | 'error' | 'success' = 'info'
  ): void {
    if (!this.messagesElement) {
      return;
    }

    const messageDiv = document.createElement('div');
    messageDiv.className = type;
    messageDiv.textContent = message;

    // Remove old message after a delay if it's a status message
    if (type !== 'error') {
      setTimeout(() => {
        messageDiv.remove();
      }, 4000);
    }

    this.messagesElement.appendChild(messageDiv);
  }

  /**
   * Clear all messages
   */
  public clearMessages(): void {
    if (this.messagesElement) {
      this.messagesElement.innerHTML = '';
    }
  }
}
